var map = {
	"./certificate_1.jpg": 8461,
	"./certificate_2.jpg": 2739,
	"./certificate_3.jpg": 1207,
	"./certificate_4.jpg": 2642,
	"./certificate_5.jpg": 3170,
	"./certificate_6.jpg": 6280,
	"./certificate_7.jpg": 9548,
	"./certificate_8.jpg": 4015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7104;